import { useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "电影", path: "/category/movie" },
  { label: "电视剧", path: "/category/tv" },
  { label: "资讯", path: "/news" },
  { label: "关于我们", path: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const isActive = (path: string) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    navigate(`/search?q=${encodeURIComponent(keyword.trim())}`);
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 group" aria-label="明明不喜欢 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50 transition-colors group-hover:bg-primary-600">
              明
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                明明不喜欢
              </span>
              <span className="mt-0.5 text-[10px] font-medium tracking-[0.2em] text-secondary-500">
                FILM &amp; TV
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`rounded-md px-3.5 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive(item.path)
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form
              onSubmit={handleSearch}
              className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3.5 py-2 md:flex"
            >
              <span className="flex h-4 w-4 items-center justify-center text-secondary-500">
                <i className="ri-search-line text-sm" />
              </span>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视作品或资讯"
                aria-label="搜索影视作品或资讯"
                className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-secondary-400 focus:outline-none xl:w-52"
              />
            </form>

            <Link
              to="/search"
              aria-label="进入搜索页"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-700 transition-colors hover:bg-background-100 md:hidden"
            >
              <i className="ri-search-line text-base" />
            </Link>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="打开导航菜单"
              aria-expanded={menuOpen}
              className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-700 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="flex flex-col px-4 py-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMenuOpen(false)}
                className={`flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-base" />
              </Link>
            ))}
            <Link
              to="/search"
              onClick={() => setMenuOpen(false)}
              className="mt-1 flex items-center justify-between rounded-md bg-accent-50 px-3 py-3 text-sm font-medium text-accent-800"
            >
              搜索影视作品
              <i className="ri-search-line text-base" />
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}